<div class="container sticker-icon" #divcointainer>
  <button mat-icon-button class="close-button" (click)="closeDialog(null)">
    <mat-icon>close</mat-icon>
  </button>

  <mat-tab-group [selectedIndex]="(stickerClone.imageData != '') ? 1 : 0">
    <mat-tab label="{{'widgets.stickers.icon' | translate}}">
      <h1 [translate]="'widgets.stickers.chooseIcon'">Choose Icon</h1>
      <div>
        <mat-form-field style="width: 98%;">
          <input cdkFocusInitial matInput placeholder="{{'widgets.stickers.search' | translate}}" [(ngModel)]="searchTerm" (ngModelChange)="search($event)" />
        </mat-form-field>
        <a class="show-all-icons" (click)="showAllIcons()" [translate]="'widgets.stickers.showAllIcons'">Show all Icons</a>

        <mat-icon *ngFor="let icon of icons;"
                  class="ip-icon"
                  (click)="selectIcon(icon)"
                  [ngClass]="{'active': icon.id == stickerClone.iconName}">{{icon.id}}
        </mat-icon>
      </div>
    </mat-tab>

    <mat-tab label="{{'widgets.stickers.image' | translate}}">
      <h1 [translate]="'widgets.stickers.chooseImage'">Choose Image</h1>
      <!-- ngx image wird nicht mehr entwickelt/unterstützt, DZ 11/23 -->
      <!--
      <ngx-img
        [imgSrc]="stickerClone.imageData"
        (onSelect)="onImageSelect($event)"
        (onChange)="onImageChange($event)"
        (onReset)="onImageReset()"
        [config]="{
          fileType: ['image/gif', 'image/jpeg', 'image/png'],
          crop: [ { ratio: 1, autoCropArea: 1, width: 512, height: 512 } ]
        }"
      >
      </ngx-img>
      -->

      <div align="end" style="margin-top: 20px;">
        <button mat-button color="warn" (click)="cancel()">{{'widgets.stickers.cancel' | translate}}</button>
        <button mat-flat-button color="primary" (click)="selectImage()">{{'widgets.stickers.save' | translate}}</button>
      </div>

    </mat-tab>
  </mat-tab-group>
</div>
